import { render } from "./Contributor.vue?vue&type=template&id=39216fc2"
import script from "./Contributor.vue?vue&type=script&lang=js"
export * from "./Contributor.vue?vue&type=script&lang=js"

import "./Contributor.vue?vue&type=style&index=0&id=39216fc2&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__